/**
 * 设备检测工具函数
 */

/**
 * 判断是否为移动端平台
 */
export const isMobilePlatform = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * 获取随机数（指定范围）
 */
export const getRandomNumberByRange = (start: number, end: number): number => {
  return Math.round(Math.random() * (end - start) + start);
};

